import { render, staticRenderFns } from "./LoadingAnnotations.vue?vue&type=template&id=90b74e8e&scoped=true&"
import script from "./LoadingAnnotations.vue?vue&type=script&lang=js&"
export * from "./LoadingAnnotations.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=90b74e8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b74e8e",
  null
  
)

export default component.exports